import * as routesUtils from '../utils/RoutesUtils'
import { API } from '../core/app.routes'
import httpClient from '../core/httpClient'
import commonService from './common.service'

const vehicleReportService = () => {
  const common = commonService()

  return {
    many: params => {
      const path = routesUtils.getApiPath(API.ADAS_REPORTS, params)
      return httpClient.get(path)
    },
    get: id => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_DETAIL, { id })
      return httpClient.get(path)
    },
    updateReadiness: ({ id, calibrationReady, note }) => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_READINESS, { id })
      return httpClient.put(path, { calibrationReady, note })
    },
    answerSafetyFeature: ({ id, featureId, answer }) => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_SAFETY_FEATURES, { id })
      return httpClient.put(path, { featureId, answer })
    },
    answerSensorQuestion: ({ id, sensorName, answer }) => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_SENSOR_ANSWER, { id })
      return httpClient.put(path, { sensorName, answer })
    },
    viewPdf: ({ id, fileName, showPricing }, targetBlank = true) => {
      let path = routesUtils.getApiPath(API.ADAS_REPORT_PDF, { id })
      const queryParams = []
      const offset = new Date().getTimezoneOffset() * -1 // minutes east of UTC (moment format)
      queryParams.push(`offset=${offset}`)
      if (showPricing) queryParams.push('showPricing=true')
      if (queryParams.length) path += `?${queryParams.join('&')}`
      return httpClient.get(path).then(res => {
        common.downloadLink(fileName || res.name || `adas_report_${id}.pdf`, res.url, targetBlank)
        return res
      })
    },
    upload: ({ vendorId, fileURL, fileName, calibrationReady, note }) => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_UPLOAD)
      return httpClient.post(path, { vendorId, fileURL, fileName, calibrationReady, note })
    },
    vendors: () => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_VENDORS)
      return httpClient.get(path)
    },
  }
}

export default vehicleReportService
